import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import * as locations from '../../../../constants/dropdown';
import {messageTextValidation, nameValidation, emailValidation, phoneValidation} from '../../../../utils/itemValidation';

import * as commonActionCreators from '../../../../actions/common';
let allActionCreators = Object.assign({}, commonActionCreators);

import RhinoSelect from '../../../common/inputs/RhinoSelect';


class Auburn2022 extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			inputName: '',
			inputLastName: '',
			inputEmail: '',
			inputPhone: '',

			errorName: null,
			errorLastName: null,
			errorEmail: null,
			errorPhone: null,
		};
	}

	internalNav(page) {
		this.context.router.push('/' + page);
	}

	externalNav(page) {
		window.location.href = '/' + page;
	}

	openNew(page) {
		let win = window.open(page, '_blank');
		win.focus();
	}

	openIntercom() {
    acquireIO.max();
  }

	changeName(evt) {
		this.setState({ inputName: evt.target.value }, () => {
			if(this.state.errorName && !nameValidation(this.state.inputName)) {
				this.setState({ errorName: null });
			}
		});
	}

	changeLastName(evt) {
		this.setState({ inputLastName: evt.target.value }, () => {
			if(this.state.errorLastName && !nameValidation(this.state.inputLastName)) {
				this.setState({ errorLastName: null });
			}
		});
	}

	changeEmail(evt) {
		this.setState({ inputEmail: evt.target.value }, () => {
			if(this.state.errorEmail && !emailValidation(this.state.inputEmail)) {
				this.setState({ errorEmail: null });
			}
		});
	}

	changePhone(evt) {
		this.setState({ inputPhone: evt.target.value }, () => {
			if(this.state.errorPhone && !phoneValidation(this.state.inputPhone)) {
				this.setState({ errorPhone: null });
			}
		});
	}

	submitContactRequest() {
		if(this.validateAll()) {

			let contactData = {
				first_name: this.state.inputName,
				last_name: this.state.inputLastName,
				email: this.state.inputEmail,
				phone: this.state.inputPhone,
			}

			this.props.commonAuburnContactRequest(contactData);

			this.props.commonAlert('Thank you for registering!', 'Continue', 'helping', '');
			this.setState({
				inputName: '',
				inputLastName: '',
				inputEmail: '',
				inputPhone: '',
				errorName: null,
				errorLastName: null,
				errorEmail: null,
				errorPhone: null,
			});
		}
	}

	validateAll() {

    let hasErrors = true;
    
    // Required params
    let nameError = nameValidation(this.state.inputName);
    let lastNameError = nameValidation(this.state.inputLastName);
    let emailError = emailValidation(this.state.inputEmail);
    let phoneError = phoneValidation(this.state.inputPhone);


    if(nameError === null &&
    	 lastNameError === null && 
       emailError === null &&
       phoneError === null) {
      hasErrors = false;
    }

    this.setState({
      errorName: nameError,
      errorLastName: lastNameError,
      errorEmail: emailError,
      errorPhone: phoneError,
    });
    return !hasErrors;
  }


	render() {

		return <div className='Auburn2022'>

			<div className='bannerWrapper'>
				<img className='desktop600' src='https://ddw2.diamondsdirect.com/img/promopages/auburn2022/auburnlander.jpg' />
					<img className='mobile600' src='https://ddw2.diamondsdirect.com/img/promopages/auburn2022/auburnlander_m.jpg' />
			</div>

			<div className='formSection'>		
				<div className='formBoxWrapper'>
					<div className='formInnerWrapper'>
						<div className={'formP left'}>Register below for a chance to be this year's Diamonds Direct Ultimate Fan Giveaway winner! One lucky winner will win:</div>
						<div className={'formP narrow'}>two tickets to the Auburn vs. Texas A&amp;M game <span className='emBig'>|</span> pre-game hospitality passes fan gear <span className='emBig'>|</span> and a $250 Diamonds Direct gift certificate.</div>
						<div className='formP'>The contest runs 10<span className='em'>/</span>17<span className='em'>/</span>22 - 11<span className='em'>/</span>7<span className='em'>/</span>22</div>
						<div className='formWrapper'>
							<div className='formInputWrapper'>
								<input 
									className={this.state.errorName ? 'textInput error' : 'textInput'}
									type='text' 
									placeholder='First Name'
									value={this.state.inputName}
                	onChange={::this.changeName} />
							</div>
							<div className='formInputWrapper'>
								<input 
									className={this.state.errorLastName ? 'textInput error' : 'textInput'}
									type='text' 
									placeholder='Last Name'
									value={this.state.inputLastName}
                	onChange={::this.changeLastName} />
							</div>
							<div className='formInputWrapper'>
								<input 
									className={this.state.errorEmail ? 'textInput error' : 'textInput'}
									type='email' 
									placeholder='Email'
									value={this.state.inputEmail}
                	onChange={::this.changeEmail} />
							</div>
							<div className='formInputWrapper'>
								<input 
									className={this.state.errorPhone ? 'textInput error' : 'textInput'}
									type='text' 
									placeholder='Phone Number'
									value={this.state.inputPhone}
                	onChange={::this.changePhone} />
							</div>
							<div className='formActionRow'>
								<button className={'formAction'} onClick={::this.submitContactRequest}>Submit Form</button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className='legalWrapper'>
				Winner will be chosen at random. No purchase necessary, must be 18 or older to win. Winner must be able to attend the game and arrange their own travel if necessary. The prize is non-transferable and for the 11/12/2022 home game only.
			</div>
		</div>;
	}
}
export default Auburn2022;

function mapStateToProps(state) {
  return {

  };
}

export const Auburn2022Container = connect(
  mapStateToProps,
  allActionCreators
)(Auburn2022);


// WEBPACK FOOTER //
// ./src/components/views/promopages/auburn2022/Auburn2022.jsx